import React from "react";
import SearchInput from "../../common/SearchInputField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { FormControl, Select, MenuItem } from "@mui/material";
import { ReactComponent as Dropdown } from "../../../assets/images/dropdown-arrow.svg";
import { PlusIcon } from "../../../utils/index";
import {
  peopleSelectControlSx,
  peopleSelectMenuProps,
  peopleSelectSx,
} from "./peopleSelectStyles";

const SELECT_VALUE_LABEL_SX = {
  flex: 1,
  minWidth: 0,
  maxWidth: "100%",
  color: "#405261",
  fontSize: 14,
  fontWeight: 400,
};

export default function PeopleToolbar({
  searchQuery,
  setSearchQuery,
  searchPlaceholder = "Search...",
  filters = [],
  primaryActionLabel,
  onPrimaryAction,
  embedded = false,
}) {
  const toolbarSelectSx = peopleSelectControlSx({ height: 40 });

  const menuSx = {
    ...peopleSelectMenuProps,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: primaryActionLabel ? "space-between" : "flex-start",
        marginTop:  24,
        marginBottom:  24,
        flexWrap: "wrap",
        gap: 8,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <div style={{ width: 296, flex: "0 0 296px" }}>
          <SearchInput
            placeholder={searchPlaceholder}
            value={searchQuery}
            className="SearchInputField-article"
            onChange={(e) => setSearchQuery(e.target.value)}
            iconPosition="left"
            iconGap={8}
            iconVariant="people"
            style={{ width: 296 }}
            inputStyle={{ width: 296 }}
            noTitle
          />
        </div>

        {filters.map((filter) => (
          <FormControl
            key={filter.key}
            size="small"
            sx={{
              ...toolbarSelectSx,
              flex: "0 1 auto",
              minWidth: filter.width || 140,
              maxWidth: filter.maxWidth ?? 220,
            }}
          >
            <Select
              value={filter.value || ""}
              onChange={(e) => filter.onChange(e.target.value)}
              IconComponent={Dropdown}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Typography component="span" noWrap sx={SELECT_VALUE_LABEL_SX}>
                      {filter.placeholder || filter.label}
                    </Typography>
                  );
                }
                const opt = (filter.options || []).find((o) => o.value === selected);
                const label = opt ? opt.label : selected;
                return (
                  <Typography component="span" noWrap sx={SELECT_VALUE_LABEL_SX}>
                    {label}
                  </Typography>
                );
              }}
              sx={{
                ...peopleSelectSx,
                height: 40,
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
              }}
              MenuProps={menuSx}
            >
              <MenuItem value="">
               All
              </MenuItem>
              {(filter.options || []).map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ))}
      </div>

      {primaryActionLabel && onPrimaryAction && (
        <Button
          variant="contained"
          disableElevation
          onClick={onPrimaryAction}
          sx={{
            minWidth: "152px",
            height: "40px",
            borderRadius: "8px",
            background: "#148DFD",
            boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
            textTransform: "none",
            "&:hover": { background: "#0f79d8" },
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "18px",
          }}
        >
          <PlusIcon />
          {primaryActionLabel}
        </Button>
      )}
    </div>
  );
}
